const dataDocs = {
    default: [{
            id: -1,
            label: 'RAC',
        },
        {
            id: -2,
            label: 'Carta de orientação'
        },
        {
            id: -3,
            label: 'Declaração de saúde'
        },
    ],
    aposentadosDemitidosDownload: [{
        id: 10,
        label: 'Termo DAP para download'
    }, ],
    aposentadosDemitidosUpload: [{
            id: 11,
            label: 'Termo DAP assinado'
        },
        {
            id: 12,
            label: 'Cópia do processo de demissão'
        },
        {
            id: 13,
            label: 'Cópia do último holerite'
        },
        {
            id: 14,
            label: 'Comprovante de residência'
        }
    ],
};

export default dataDocs;